import type { BodyState } from "../physics/body";

/**
 * The highest surface under an area of the grid, seen from above, using each
 * block's bounding box (AABB): the base at 0, or -Infinity over the void,
 * raised by every overlapping block that `counts` accepts.
 */
export function surfaceTop<B extends BodyState>(
  blocks: readonly B[],
  x0: number,
  x1: number,
  z0: number,
  z1: number,
  counts: (b: B) => boolean,
): number {
  let top = x1 > -12 && x0 < 12 && z1 > -12 && z0 < 12 ? 0 : -Infinity; // base, or nothing (the void)
  for (const b of blocks) {
    const a = b.aabb;
    const overlaps =
      a.lowerBound.x < x1 && a.upperBound.x > x0 && a.lowerBound.z < z1 && a.upperBound.z > z0;
    if (overlaps && counts(b)) top = Math.max(top, a.upperBound.y);
  }
  return top;
}
